import { render } from "./MerchantDashboard.vue?vue&type=template&id=6bb71bf6&ts=true"
import script from "./MerchantDashboard.vue?vue&type=script&lang=ts"
export * from "./MerchantDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__